module.exports = __webpack_public_path__ + "img/i_shenzhen.a08575fd.png";